// PODCAST_DOWNLOADS
export const REQUEST_PODCAST_DOWNLOADS = 'REQUEST_PODCAST_DOWNLOADS'
export const SET_PODCAST_DOWNLOADS = 'SET_PODCAST_DOWNLOADS'
export const SET_PODCAST_DOWNLOADS_ERROR = 'SET_PODCAST_DOWNLOADS_ERROR'

// EPISODE_DOWNLOADS
export const REQUEST_EPISODE_DOWNLOADS = 'REQUEST_EPISODE_DOWNLOADS'
export const SET_EPISODE_DOWNLOADS = 'SET_EPISODE_DOWNLOADS'
export const SET_EPISODE_DOWNLOADS_ERROR = 'SET_EPISODE_DOWNLOADS_ERROR'
